/* ============================================================
   ASPIRI — aspiri-animations.js
   Professional bidirectional scroll animations
   ↓ Scroll down  → elements animate IN
   ↓ Scroll past  → elements EXIT upward (subtle)
   ↑ Scroll up    → elements RE-ANIMATE as they come back
   ============================================================ */
(function () {
  'use strict';

  var NO_ANIM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     SCROLL PROGRESS BAR
     ============================================================ */
  var bar = document.createElement('div');
  bar.id = 'aspiri-scroll-progress';
  document.body.insertBefore(bar, document.body.firstChild);

  window.addEventListener('scroll', function () {
    var s = window.scrollY;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = (h > 0 ? Math.min(s / h * 100, 100) : 0) + '%';
  }, { passive: true });

  if (NO_ANIM) {
    /* Show everything immediately for reduced-motion users */
    document.querySelectorAll('.aspiri-anim').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  /* ============================================================
     ONE-TIME INTERSECTION OBSERVER (Animates Once)
     ============================================================ */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('anim-in');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  });

  /* ============================================================
     REGISTER HELPER
     ============================================================ */
  function register(el, direction, delay) {
    if (!el || el.classList.contains('aspiri-anim')) return;
    el.classList.add('aspiri-anim');
    if (direction) el.classList.add(direction);
    if (delay)     el.classList.add(delay);
    observer.observe(el);
  }

  function registerAll(list, direction, delayFn) {
    Array.prototype.forEach.call(list, function (el, i) {
      register(el, direction, delayFn ? delayFn(i) : null);
    });
  }

  var DELAYS = [null,'anim-d1','anim-d2','anim-d3','anim-d4','anim-d5','anim-d6','anim-d7'];
  function stagger(i) { return DELAYS[Math.min(i, DELAYS.length - 1)] || null; }

  function makeStaggerObserver(cards, direction) {
    registerAll(cards, direction, stagger);
    return { observe: function() {} };
  }

  /* ============================================================
     WIRE UP ALL 8 HOME SECTIONS
     ============================================================ */
  function init() {

    /* ----------------------------------------------------------
       SECTION 1: HERO SLIDER
       Handled via CSS @keyframes on page load — no JS needed
    ---------------------------------------------------------- */

    /* ----------------------------------------------------------
       SECTION 2: STORE FEATURES
       4 feature items, staggered up
    ---------------------------------------------------------- */
    document.querySelectorAll('[class*="features-section-"]').forEach(function (sec) {
      var items = sec.querySelectorAll('[class*="feature-item-"]');
      registerAll(items, 'from-up', stagger);
    });

    /* ----------------------------------------------------------
       SECTION 3: SHOP BY CATEGORY (desktop only)
       Animation removed as per user request
    ---------------------------------------------------------- */

    /* ----------------------------------------------------------
       SECTION 4: JEWELRY PROMO SLIDER
       Banner ← left | Slider area → right (desktop)
       Mobile: both from-up (CSS override)
       Product cards stagger via stagger-observer
    ---------------------------------------------------------- */
    document.querySelectorAll('[class*="promo-banner-"]').forEach(function (el) {
      register(el, 'from-left');
    });
    document.querySelectorAll('[class*="promo-slider-area-"]').forEach(function (el) {
      register(el, 'from-right');
    });

    document.querySelectorAll('[id*="productTrack-"]').forEach(function (track) {
      var cards = track.querySelectorAll('[class*="product-card-"]');
      if (cards.length) {
        var obs = makeStaggerObserver(cards, 'from-up');
        obs.observe(track);
      }
    });

    /* ----------------------------------------------------------
       SECTION 5: 40/60 SPLIT GALLERY
       Left image ← | Right image →
       Mobile: both up
    ---------------------------------------------------------- */
    document.querySelectorAll('[class*="jewelry-promo-grid-"]').forEach(function (grid) {
      var items = grid.querySelectorAll('[class*="promo-item-"]');
      items.forEach(function (item, i) {
        register(item, i === 0 ? 'from-left' : 'from-right', i === 1 ? 'anim-d1' : null);
      });
    });

    /* ----------------------------------------------------------
       SECTION 6: EXPLORE COLLECTION SLIDER
       Header fades up, cards stagger via stagger-observer
    ---------------------------------------------------------- */
    document.querySelectorAll('[class*="collection-section-"]').forEach(function (sec) {
      var hdr = sec.querySelector('.section-header');
      if (hdr) register(hdr, 'from-up');

      var wrapper = sec.querySelector('.slider-wrapper');
      if (wrapper) {
        var cards = sec.querySelectorAll('.card');
        if (cards.length) {
          var obs = makeStaggerObserver(cards, 'from-up');
          obs.observe(wrapper);
        }
      }
    });

    /* ----------------------------------------------------------
       SECTION 7: SHOP THE LOOK
       Product grid ← | Hero image →
       Each product-card staggered inside grid
       Mobile: both up
    ---------------------------------------------------------- */
    document.querySelectorAll('.shop-the-look-container').forEach(function (container) {
      var grid = container.querySelector('.product-grid');
      var hero = container.querySelector('.hero-section');
      if (grid) register(grid, 'from-left');
      if (hero) register(hero, 'from-right', 'anim-d1');

      if (grid) {
        registerAll(grid.querySelectorAll('.product-card'), 'from-up', stagger);
      }
    });

    /* ----------------------------------------------------------
       SECTION 8: LUXE PROMO CARDS
       card-odd ← | card-even →
       Mobile: both up
    ---------------------------------------------------------- */
    document.querySelectorAll('.luxe-card').forEach(function (card) {
      var dir = card.classList.contains('card-even') ? 'from-right' : 'from-left';
      var del = card.classList.contains('card-even') ? 'anim-d1'   : null;
      register(card, dir, del);
    });

    /* ----------------------------------------------------------
       GENERIC FALLBACK: any remaining data-anim or section-header
    ---------------------------------------------------------- */
    document.querySelectorAll('[data-anim]').forEach(function (el) {
      register(el, 'from-' + (el.dataset.anim || 'up'));
    });
    document.querySelectorAll('.section-header:not(.aspiri-anim)').forEach(function (el) {
      register(el, 'from-up');
    });

    // Observe any element that already has the aspiri-anim class hardcoded in HTML
    document.querySelectorAll('.aspiri-anim').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ============================================================
     SMOOTH ANCHOR SCROLL
     ============================================================ */
  function initAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (!href || href === '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.site-header, header');
        var offset = (header ? header.offsetHeight : 0) + 16;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
      });
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function boot() {
    init();
    initAnchors();
    
    if (NO_ANIM) return;

    /* ============================================================
       LENIS SMOOTH SCROLLING (from Codepen reference)
       ============================================================ */
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/lenis@1.1.5/dist/lenis.min.js';
    script.onload = function () {
      var lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: "vertical",
        gestureOrientation: "vertical",
        smoothWheel: true,
        smoothTouch: true,
        touchMultiplier: 2,
        autoRaf: false
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);

      // Update progress bar without hijacking native scroll events
      var bar = document.getElementById('aspiri-scroll-progress');
      lenis.on('scroll', function(e) {
        var max = e.limit;
        var progress = max > 0 ? (e.scroll / max) * 100 : 0;
        if(bar) bar.style.width = Math.min(progress, 100) + '%';
      });
    };
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
